import { createFileRoute } from "@tanstack/react-router";

import { MorePage } from "../../../../areas/seller/more/MorePage";

export const Route = createFileRoute("/app/_seller/more/")({
  component: MorePage,
});
